"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferFromL1CompletedTopic = exports.tokenTransferTopic = exports.tokensBridgedTopic = exports.transferSentToL2Topic = exports.transferSentTopic = void 0;
exports.transferSentTopic = '0xe35dddd4ea75d7e9b3fe93af4f4e40e778c3da4074c9d93e7c6536f1e803c1eb';
exports.transferSentToL2Topic = '0x0a0607688c86ec1775abcdbab7b33a3a35a6c9cde677c9be880150c231cc6b0b';
exports.tokensBridgedTopic = '0x9afd47907e25028cdaca89d193518c302bbb128617d5a992c5abd45815526593';
exports.tokenTransferTopic = '0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef';
exports.transferFromL1CompletedTopic = '0x320958176930804eb66c2343c7343fc0367dc16249590c0f195783bee199d094';
